import React from "react";
import { FaqMarkdownPage } from "../../components/FaqMarkdownPage";

// Routed at /faq/work-vs-project-experience — content lives entirely in
// public/locales/faq/work-vs-project-experience.*.md, editable without touching this file.
export const WorkVsProjectExperienceFaqPage: React.FC = () => (
    <FaqMarkdownPage
        titleKey="FAQ_WORK_VS_PROJECT_EXPERIENCE_TITLE"
        titleFallback="Work Experience vs Project Experience"
        markdownBasePath="/locales/faq/work-vs-project-experience"
    />
);
